function RealTimeCounter() {
	var counter = $('.real-time-counter');

	if (counter.length) {
		var date = new Date();

		var serviceUrlHeitz = '/wp-json/wellness-front/v1/real-time-counter/?t=' + date.getTime() + '&service=heitz&fmiID=';
		var serviceUrlGsInfo = '/wp-json/wellness-front/v1/real-time-counter/?t=' + date.getTime() + '&service=gsinfo&fmiID=';
		var serviceUrl;


		counter.each(function(index, elem) {
			var id = $(elem).data('fmi-id');
			var service = $(elem).data('fmi-service');

			if (service == "heitz") {
				serviceUrl = serviceUrlHeitz;

			} else if (service == "gsinfo") {
				serviceUrl = serviceUrlGsInfo;
			} else {
				return;
			}

			$.get(serviceUrl + id, function( data ) {
				var currentCount = data.counter;
				var target = $(elem).find('.counter');

				if (currentCount) {
					target.text(currentCount);
				} else {
					$(elem).addClass('no-data');
				}
			});
		});
	}
}